define('plugin/product/model/ProductCartModel',['require','lib/model/BaseModel','plugin/invoice/model/InvoiceModel','Config'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var InvoiceModel = require('plugin/invoice/model/InvoiceModel');
    var Config = require('Config');

    return BaseModel.extend({

        url: '/ext/product/cart',
        invoiceUrl: '/ext/product/invoice',

        defaults: {
            key: 'product',
            id: null,
            items: null,
            invoice: null
        },

        initialize: function () {
            BaseModel.prototype.initialize.call(this, arguments);

            if (this.invoiceUrl && _.isString(this.invoiceUrl)) {
                this.invoiceUrl = this.baseUrl + _.result(this, 'invoiceUrl');
            }
        },

        parse: function (data) {
            var res = BaseModel.prototype.parse.call(this, data) || {};

            if (res.items) {
                res.items = new Backbone.Collection(data.items);
            }

            if (res.invoice) {
                res.invoice = new InvoiceModel(res.invoice);
            }

            return res;
        },

        addItem: function (product, qty) {
            var items = this.get('items');
            if (!items) {
                items = new Backbone.Collection();
                this.set('items', items);
            }
            var item = items.get(product.get('id'));

            if (item) {
                item.set('qty', item.get('qty') + qty);
            } else {
                items.add({
                    id: product.get('id'),
                    product: product.toJSON(),
                    qty: qty
                });
            }

            this.trigger('change');
            this.trigger('add:item');
            this.store(); // keep cart in server session
        },

        createInvoice: function (options) {
            this.save(null, _.extend({
                method: 'POST',
                url: this.invoiceUrl
            }, options));
        },

        isEmpty: function () {
            return !this.get('items') || this.get('items').length === 0;
        },

        getQty: function () {
            var items = this.get('items');
            if (!items || !items.length) return 0;

            return items.reduce(function (memo, item) {
                return memo + item.get('qty');
            }, 0);
        },

        getTax: function () {
            var items = this.get('items');
            if (!items || !items.length) return 0;

            return items.reduce(function (memo, item) {
                var taxAmount = 0;
                if (item.get('product').tax) {
                    var taxRate = item.get('product').tax.ratio;

                    if (!Config.getInstance().getOption('price_includes_tax')) {
                        taxAmount = item.get('qty') * item.get('product').price * taxRate;
                    } else {
                        taxAmount = taxRate * item.get('qty') * item.get('product').price / (1 + taxRate);
                    }
                }
                return memo + taxAmount;
                
            }, 0);
        },

        getTotal: function () {
            var items = this.get('items');
            if (!items || !items.length) return 0;

            return items.reduce(function (memo, item) {
                return memo + item.get('qty') * item.get('product').price;
            }, 0);
        },

        getCurrency: function () {
            var items = this.get('items');
            if (!items || !items.length) return null;

            return items.at(0).get('product').currency;
        },

        contains: function (id) {
            var items = this.get('items');
            if (!items) return false;

            return !!items.get(id);
        },

        load: function() {
            if (!this.get('items')) {
                this.set('items', new Backbone.Collection());
            }
            var items = this.get('items');

            var stored = window.sessionStorage.getItem('product_cart');

            if (stored) {
                try {
                    var data = JSON.parse(stored);
                    items.reset(data);

                    setTimeout(this.trigger.bind(this, 'sync'), 500);
                } catch (e) {
                    console.log(e);
                }
            }
        },

        store: function() {
            var items = this.get('items');
            window.sessionStorage.setItem('product_cart', JSON.stringify(items ? items.toJSON() : null));
            this.trigger('sync');
        },

        clear: function() {
            this.set({
                id: null,
                invoice: null,
                items: null
            });
            this.store();
        },
        
        getServiceIds: function() {
            return [];
        },

        getProductIds: function() {
            var items = this.get('items');
            if (!items || !items.length) return [];

            return items.pluck('id');
        }

    });

});
